/* eslint-disable no-undef */
/* eslint-disable import/no-cycle */
import Observer from './vendor/observer.min';
import { formsPackage } from './functions/form';
import masksPackage from './functions/masks';
import setConditions from './functions/conditions';
import limitedCheckboxLists from './functions/limitedCheckboxLists';
import { removeRepeaterSection, refreshScripts } from './functions/repeaters';

export const OBSERVER = Observer.getInstance();

export const initFormBuilder = (classeContainerFormBuilder = '.dynamicForm') => {
  formsPackage(classeContainerFormBuilder);
  masksPackage();
  initFileUpload(classeContainerFormBuilder);
  setConditions(classeContainerFormBuilder);
  limitedCheckboxLists();
};

// eslint-disable-next-line no-restricted-globals
addEventListener('DOMContentLoaded', () => {
  initFormBuilder();
});

window.initFormBuilder = initFormBuilder;
window.removeRepeaterSection = removeRepeaterSection;
window.refreshScripts = refreshScripts;
